import { emptyGuid, isGuidEmpty } from "@utilities/commonUtilities";
import { loanLibraryInventoryItemModel } from "@containers/Library/LoanLibrary/LoanLibraryCatalogItem/LoanLibraryInventoryItem/loanLibraryInventoryItemFactory";

export const loanLibraryCatalogItemModel = ({
                                                accessNumber,
                                                accessoriesAndParts,
                                                author,
                                                catalogNumber,
                                                cost,
                                                dateCreatedUtc,
                                                dateModifiedUtc,
                                                dateOfPurchase,
                                                description,
                                                inventoryItems,
                                                isActive,
                                                isForInternalUse,
                                                keywords,
                                                loanLibraryCatalogId = emptyGuid,
                                                loanTerms,
                                                manufacturerId,
                                                mediaFormat,
                                                notes,
                                                productName,
                                                publicationDate,
                                                quantityCurrentlyAvailable,
                                                recommendedQuantity,
                                                relatedItems,
                                                totalQuantity,
                                                vendorId,
                                                whatsNewStartDate,
                                                whatsNewEndDate,
                                            }: Record<string, any> = {}) => ({
    accessNumber,
    accessoriesAndParts,
    author,
    catalogNumber,
    cost,
    dateCreatedUtc,
    dateModifiedUtc,
    dateOfPurchase,
    description: description || '',
    inventoryItems: Array.isArray(inventoryItems)
        ? inventoryItems.map((item: Record<string, any>) => loanLibraryInventoryItemModel(item))
        : [],
    isActive,
    isForInternalUse: isForInternalUse || false,
    keywords,
    loanLibraryCatalogId,
    loanTerms,
    manufacturerId: isGuidEmpty(manufacturerId) ? null : manufacturerId,
    mediaFormat,
    notes: notes || '',
    productName,
    publicationDate,
    quantityCurrentlyAvailable,
    recommendedQuantity,
    relatedItems,
    totalQuantity,
    vendorId: isGuidEmpty(vendorId) ? null : vendorId,
    whatsNewStartDate,
    whatsNewEndDate,
});
export const emptyLoanLibraryCatalogItemModel = loanLibraryCatalogItemModel();